






































import { Component, Vue } from "vue-property-decorator";

@Component
export default class About extends Vue {
  onclickVideo(): void {
    this.$store.state.srcVideo = "https://www.youtube.com/embed/GfMY59bZbTs";
    this.$store.state.closePopUp = false;
  }
}
